/**
 * import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
 * import { jwtDecode } from "jwt-decode";
 * import api from "../../api/api";
 *
 * // Centralisation des routes API
 * const API_ROUTES = {
 *     ADMIN_LOGIN: '/api/admin_login',
 *     SELLER_LOGIN: '/api/seller_login',
 *     SELLER_REGISTER: '/api/seller_register',
 *     GET_USER: '/api/get_user',
 *     UPLOAD_IMAGE: '/api/profile/uploadImage',
 *     LOGOUT: '/api/logout',
 *     SELLER_INFO : '/api/profile/seller_infos',
 * };
 *
 * // Fonction utilitaire pour la gestion des messages d'erreur
 * const getErrorMessage = (error) => error.response?.data.message || error.message;
 *
 * // Vérification et décodage du token
 * const returnRole = (token) => {
 *     if (token) {
 *         try {
 *             const decodedToken = jwtDecode(token);
 *             const expireTime = new Date(decodedToken.exp * 1000);
 *             if (new Date() > expireTime) {
 *                 localStorage.removeItem('accessToken');
 *                 return '';
 *             }
 *             return decodedToken.role;
 *         } catch (error) {
 *             //console.error("Erreur lors du décodage du token :", error);
 *             localStorage.removeItem('accessToken');
 *             return '';
 *         }
 *     }
 *     return '';
 * };
 *
 * // Action pour la connexion de l'admin
 * export const admin_login = createAsyncThunk(
 *     "auth/admin_login",
 *     async (info, { rejectWithValue, fulfillWithValue }) => {
 *         try {
 *             const { data } = await api.post(API_ROUTES.ADMIN_LOGIN, info, { withCredentials: true });
 *            // console.log(' admin _login :', data);
 *             localStorage.setItem('accessToken', data.token);
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *            // console.error("Erreur lors de la connexion de l'admin :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 * // Action pour la connexion du vendeur
 * export const seller_login = createAsyncThunk(
 *     "auth/seller_login",
 *     async (info, { rejectWithValue, fulfillWithValue }) => {
 *         try {
 *             const { data } = await api.post(API_ROUTES.SELLER_LOGIN, info, { withCredentials: true });
 *             localStorage.setItem('accessToken', data.token);
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *            // console.error("Erreur lors de la connexion du vendeur :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 * // Action pour l'inscription du vendeur
 * export const seller_register = createAsyncThunk(
 *     "auth/seller_register",
 *     async (info, { rejectWithValue, fulfillWithValue }) => {
 *         try {
 *             const { data } = await api.post(API_ROUTES.SELLER_REGISTER, info, { withCredentials: true });
 *             localStorage.setItem('accessToken', data.token);
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *             //console.error("Erreur lors de l'inscription du vendeur :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 * // Action pour récupérer les informations utilisateur
 * export const get_user_info = createAsyncThunk(
 *     "auth/get_user",
 *     async (_, { rejectWithValue, fulfillWithValue }) => {
 *         try {
 *             const token = localStorage.getItem('accessToken');
 *             const { data } = await api.get(API_ROUTES.GET_USER, {
 *                 withCredentials: true,
 *                 headers: { Authorization: `Bearer ${token}` },
 *             });
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *             console.error("Erreur lors de la récupération des informations utilisateur :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 *
 * export const profile_info_add = createAsyncThunk(
 *     "auth/profile_info_add",
 *     async (profileInfo, { rejectWithValue, fulfillWithValue }) => {
 *         console.log('profil infos bruts',profileInfo)
 *         try {
 *             const { data } = await api.post(API_ROUTES.SELLER_INFO, profileInfo, {withCredentials : true});
 *             console.log(' api shop infos ', data);
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *            // console.error("Erreur lors de la récupération des informations de la boutique :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *
 *         }
 *     }
 *   )
 *
 * // Action pour uploader une image de profil
 * export const uploadProfileImage = createAsyncThunk(
 *     "auth/uploadProfileImage",
 *     async (formData, { rejectWithValue, fulfillWithValue }) => {
 *         try {
 *             const { data } = await api.post(API_ROUTES.UPLOAD_IMAGE, formData, {
 *                 withCredentials: true,
 *                 headers: { "Content-Type": "multipart/form-data" },
 *             });
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *             //console.error("Erreur lors de l'upload de l'image :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 * // Action pour la déconnexion
 * export const logout = createAsyncThunk(
 *     "auth/logout",
 *     async ({role, navigate}, { rejectWithValue, fulfillWithValue }) => {
 *
 *         try {
 *             const { data } = await api.get(API_ROUTES.LOGOUT, { withCredentials: true });
 *
 *             localStorage.removeItem('accessToken'); // Supprimer le token ici
 *            //const redirectPath = role === 'seller' ? '/login' : '/admin/login';
 *            // console.log('redirectPath', redirectPath);
 *             //setTimeout(() => navigate(redirectPath), 0); // Redirection après suppression
 *            //navigate(redirectPath);
 *            if (role!=='seller') {
 *             navigate('/admin/login')
 *            } else {
 *             navigate('/login')
 *            }
 *             return fulfillWithValue(data);
 *         } catch (error) {
 *            // console.error("Erreur lors de la déconnexion :", error);
 *             return rejectWithValue(getErrorMessage(error));
 *         }
 *     }
 * );
 *
 * @format
 */

/*export const logout = createAsyncThunk(
    "auth/logout",
    async ({ navigate, role }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.LOGOUT, { withCredentials: true });
            localStorage.removeItem('accessToken');
            const redirectPath = role === 'admin' ? '/admin/login' : '/login';
            navigate(redirectPath);
            return fulfillWithValue(data);
        } catch (error) {
            console.error("Erreur lors de la déconnexion :", error);
            return rejectWithValue(getErrorMessage(error));
        }
    }
);
*/

/*

// Reducer principal
export const authReducer = createSlice({
    name: "auth",
    initialState: {
        successMessage: "",
        errorMessage: "",
        loader: false,
        isAuthenticated : false,
        userInfo: "",
        role: returnRole(localStorage.getItem("accessToken")), // Récupère le rôle depuis le token
        token: localStorage.getItem("accessToken")|| "", // Récupère le token depuis le localStorage
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(admin_login.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(admin_login.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.token = action.payload.token;
                state.role = returnRole(action.payload.token);
                state.userInfo = jwtDecode(action.payload.token);
                state.isAuthenticated = true;
            })
            .addCase(admin_login.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload;
            })
            .addCase(seller_login.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(seller_login.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.token = action.payload.token;
                state.role = returnRole(action.payload.token);
                state.userInfo = jwtDecode(action.payload.token);
            })
            .addCase(seller_login.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload;
            })

            .addCase(seller_register.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(seller_register.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.token = action.payload.token;
                state.role = returnRole(action.payload.token);
                state.userInfo = jwtDecode(action.payload.token);
            })
            .addCase(get_user_info.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(get_user_info.fulfilled, (state, action) => {
                state.loader = false;
                state.isAuthenticated  = true;
                state.successMessage = action.payload.message;
                state.userInfo = action.payload.userInfo;
                
            })
            .addCase(uploadProfileImage.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(uploadProfileImage.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.userInfo = {
                    ...state.userInfo,
                    image: action.payload.image,
                };
            })
            .addCase(profile_info_add.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(profile_info_add.fulfilled, (state, action) => {
                state.loader = false
                state.successMessage = action.payload.message
                state.userInfo = {
                    ...state.userInfo,
                    ...action.payload.userInfo,
                }

            })
             .addCase(logout.fulfilled, (state) => {
            state.token = ""; // Réinitialiser le token dans le state
            state.role = ""; // Réinitialiser le rôle
            state.isAuthenticated = false; // Mettre à jour l'état d'authentification
            state.userInfo = ""; // Réinitialiser les informations utilisateur
            state.successMessage = "";
        })
        .addCase(logout.rejected, (state, action) => {
            state.errorMessage = action.payload || "Erreur lors de la déconnexion";
        });
    },
});

export const { setUserInfo, messageClear } = authReducer.actions;
export default authReducer.reducer;
*/
/*
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

const API_ROUTES = {
    ADMIN_LOGIN: '/api/admin_login',
    SELLER_LOGIN: '/api/seller_login',
    SELLER_REGISTER: '/api/seller_register',
    GET_USER: '/api/get_user',
    UPLOAD_IMAGE: '/api/profile/uploadImage',
    LOGOUT: '/api/logout',
    SELLER_INFO : '/api/profile/seller_infos',
};

const getErrorMessage = (error) => error.response?.data.message || error.message;

// Authentification
export const admin_login = createAsyncThunk(
    "auth/admin_login",
    async (info, { rejectWithValue, fulfillWithValue, dispatch }) => {
        try {
            const { data } = await api.post(API_ROUTES.ADMIN_LOGIN, info, { withCredentials: true });
            await dispatch(get_user_info());
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const seller_login = createAsyncThunk(
    "auth/seller_login",
    async (info, { rejectWithValue, fulfillWithValue, dispatch }) => {
        try {
            const { data } = await api.post(API_ROUTES.SELLER_LOGIN, info, { withCredentials: true });
            await dispatch(get_user_info());
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const seller_register = createAsyncThunk(
    "auth/seller_register",
    async (info, { rejectWithValue, fulfillWithValue, dispatch }) => {
        try {
            const { data } = await api.post(API_ROUTES.SELLER_REGISTER, info, { withCredentials: true });
            await dispatch(get_user_info());
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const get_user_info = createAsyncThunk(
    "auth/get_user",
    async (_, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.GET_USER, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const profile_info_add = createAsyncThunk(
    "auth/profile_info_add",
    async (profileInfo, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.SELLER_INFO, profileInfo, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const uploadProfileImage = createAsyncThunk(
    "auth/uploadProfileImage",
    async (formData, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.UPLOAD_IMAGE, formData, {
                withCredentials: true,
                headers: { "Content-Type": "multipart/form-data" },
            });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const logout = createAsyncThunk(
    "auth/logout",
    async ({ role, navigate }, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.get(API_ROUTES.LOGOUT, { withCredentials: true });
            if (role !== 'seller') {
                navigate('/admin/login');
            } else {
                navigate('/login');
            }
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);

export const authReducer = createSlice({
    name: "auth",
    initialState: {
        successMessage: "",
        errorMessage: "",
        loader: false,
        isAuthenticated: false,
        userInfo: {},
        role: '',
    },
    reducers: {
        setUserInfo: (state, action) => {
            state.userInfo = action.payload;
        },
        messageClear: (state) => {
            state.errorMessage = "";
            state.successMessage = "";
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(admin_login.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(admin_login.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
            })
            .addCase(admin_login.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload;
            })
            .addCase(seller_login.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(seller_login.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
            })
            .addCase(seller_login.rejected, (state, action) => {
                state.loader = false;
                state.errorMessage = action.payload;
            })
            .addCase(seller_register.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(seller_register.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
            })
            .addCase(get_user_info.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(get_user_info.fulfilled, (state, action) => {
                state.loader = false;
                state.isAuthenticated = true;
                state.successMessage = action.payload.message;
                state.userInfo = action.payload.userInfo;
                state.role = action.payload.userInfo?.role || '';
            })
            .addCase(get_user_info.rejected, (state) => {
                state.loader = false;
                state.isAuthenticated = false;
                state.userInfo = {};
                state.role = '';
            })
            .addCase(uploadProfileImage.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(uploadProfileImage.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.userInfo = {
                    ...state.userInfo,
                    image: action.payload.image,
                };
            })
            .addCase(profile_info_add.pending, (state) => {
                state.loader = true;
                state.errorMessage = "";
            })
            .addCase(profile_info_add.fulfilled, (state, action) => {
                state.loader = false;
                state.successMessage = action.payload.message;
                state.userInfo = {
                    ...state.userInfo,
                    ...action.payload.userInfo,
                };
            })
            .addCase(logout.fulfilled, (state) => {
                state.isAuthenticated = false;
                state.userInfo = {};
                state.role = '';
                state.successMessage = 'Déconnecté avec succès';
            })
            .addCase(logout.rejected, (state, action) => {
                state.errorMessage = action.payload || "Erreur lors de la déconnexion";
            });
    },
});

export const { setUserInfo, messageClear } = authReducer.actions;
export default authReducer.reducer;
*/

import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import api from "../../api/api";

const API_ROUTES = {
  ADMIN_LOGIN: "/api/admin_login",
  SELLER_LOGIN: "/api/seller_login",
  SELLER_REGISTER: "/api/seller_register",
  GET_USER: "/api/get_user",
  UPLOAD_IMAGE: "/api/profile/uploadImage",
  LOGOUT: "/api/logout",
  SELLER_INFO: "/api/profile/seller_infos",
};

const getErrorMessage = (error) =>
  error.response?.data.message || error.message;

// Authentification
export const admin_login = createAsyncThunk(
  "auth/admin_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.ADMIN_LOGIN, info, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const seller_login = createAsyncThunk(
  "auth/seller_login",
  async (info, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.SELLER_LOGIN, info, {
        withCredentials: true,
      });
      //console.log('data response', data);
      return fulfillWithValue(data);
    } catch (error) {
      // console.log('error response', error.response?.data);
      if (error.response?.status === 403) {
        return rejectWithValue({
          verify: true,
          email: error.response.data.email,
          message: error.response.data.message,
        });
      }
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

/*
export const seller_register = createAsyncThunk(
    "auth/seller_register",
    async (info, { rejectWithValue, fulfillWithValue }) => {
        try {
            const { data } = await api.post(API_ROUTES.SELLER_REGISTER, info, { withCredentials: true });
            return fulfillWithValue(data);
        } catch (error) {
            return rejectWithValue(getErrorMessage(error));
        }
    }
);*/

export const seller_register = createAsyncThunk(
  "auth/seller_register",
  async (info, { rejectWithValue, fulfillWithValue, dispatch }) => {
    try {
      const { data } = await api.post(API_ROUTES.SELLER_REGISTER, info, {
        withCredentials: true,
      });
      await dispatch(get_user_info());
      return fulfillWithValue(data);
    } catch (error) {
      console.log("error response", error.response?.data);

      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const get_user_info = createAsyncThunk(
  "auth/get_user",
  async (_, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.GET_USER, {
        withCredentials: true,
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const profile_info_add = createAsyncThunk(
  "auth/profile_info_add",
  async (profileInfo, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.SELLER_INFO, profileInfo, {
        withCredentials: true,
      });
      //console.log('profile data ', data);
      return fulfillWithValue(data);
    } catch (error) {
      console.log("error response", error.response?.data);
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const uploadProfileImage = createAsyncThunk(
  "auth/uploadProfileImage",
  async (formData, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.post(API_ROUTES.UPLOAD_IMAGE, formData, {
        withCredentials: true,
        headers: { "Content-Type": "multipart/form-data" },
      });
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const logout = createAsyncThunk(
  "auth/logout",
  async ({ role, navigate }, { rejectWithValue, fulfillWithValue }) => {
    try {
      const { data } = await api.get(API_ROUTES.LOGOUT, {
        withCredentials: true,
      });
      if (role === "admin") {
        navigate("/admin/login");
      } else {
        navigate("/login");
      }
      return fulfillWithValue(data);
    } catch (error) {
      return rejectWithValue(getErrorMessage(error));
    }
  },
);

export const authReducer = createSlice({
  name: "auth",
  initialState: {
    successMessage: "",
    errorMessage: "",
    loader: true,
    isAuthenticated: false,
    userInfo: {},
    role: "",
    loggedOut: true, // 🆕
    customerToken: "",
    token: "",
    profileLoader: false,
    profileMessage: "",
    profileError: "",
  },
  reducers: {
    setUserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    messageClear: (state) => {
      state.errorMessage = "";
      state.successMessage = "";
      state.profileMessage = "";
      state.profileError = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(admin_login.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(admin_login.fulfilled, (state, action) => {
        state.loader = false;
        state.token = action.payload.token;
        state.userInfo = action.payload.userInfo;
        state.successMessage = action.payload.message;
        state.isAuthenticated = true;
      })
      .addCase(admin_login.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload;
      })

      .addCase(seller_login.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(seller_login.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.isAuthenticated = true;
        state.userInfo = action.payload.userInfo;
        state.customerToken = action.payload.customerToken;
      })
      .addCase(seller_login.rejected, (state, action) => {
        state.loader = false;
        state.errorMessage = action.payload.message;
      })

      .addCase(seller_register.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(seller_register.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.isAuthenticated = true;
      })

      .addCase(get_user_info.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(get_user_info.fulfilled, (state, action) => {
        state.loggedOut = false; // 🆕 reset si on récupère l'utilisateur
        state.loader = false;
        state.isAuthenticated = true;
        state.successMessage = action.payload.message;
        state.userInfo = action.payload.userInfo;
        // console.log('role get _user_info', action.payload.userInfo.role);
        state.role = action.payload.userInfo?.role || "";
        if (action.payload.userInfo?.role === "seller") {
          state.customerToken = action.payload.customerToken;
        }
      })
      .addCase(get_user_info.rejected, (state) => {
        state.loggedOut = true; // 🆕 reset si on récupère l'utilisateur
        state.loader = false;
        state.isAuthenticated = false;
        state.userInfo = {};
        state.role = "";
      })

      .addCase(uploadProfileImage.pending, (state) => {
        state.loader = true;
        state.errorMessage = "";
      })
      .addCase(uploadProfileImage.fulfilled, (state, action) => {
        state.loader = false;
        state.successMessage = action.payload.message;
        state.userInfo = {
          ...state.userInfo,
          image: action.payload.image,
        };
      })

      .addCase(profile_info_add.pending, (state) => {
        state.profileLoader = true;
        state.profileError = "";
      })
      .addCase(profile_info_add.fulfilled, (state, action) => {
        state.profileLoader = false;
        state.profileMessage = action.payload.message;
        state.userInfo = {
          ...state.userInfo,
          ...action.payload.userInfo,
        };
      })

      .addCase(profile_info_add.rejected, (state, action) => {
        state.profileLoader = false;
        state.profileError = action.payload;
      })

      .addCase(logout.fulfilled, (state) => {
        state.loggedOut = true; // 🆕
        state.isAuthenticated = false;
        state.userInfo = {};
        state.role = "";
        state.successMessage = "Déconnecté avec succès";
      })
      .addCase(logout.rejected, (state, action) => {
        state.errorMessage = action.payload || "Erreur lors de la déconnexion";
      });
  },
});

export const { setUserInfo, messageClear } = authReducer.actions;
export default authReducer.reducer;
